// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/js/" + chunkId + "-" + {"475": "64a56310882d0091","596": "f2362c054f7374b4",}[chunkId] + ".js"
}